import axios from 'axios'
import {authUrl} from '../api/auth_http'

const service = axios.create({
  timeout: 5000
})

// 添加请求拦截器
service.interceptors.request.use(function (config) {
  switch (config.urltype) {
    case 'auth':
      config.url = authUrl + config.url;
      config.headers = {
        "Content-Type": 'application/json',
        "app": 'member_activity'
      }
      break

    case 'share':
      config.url = 'https://auth-v3.wukongkeyan.com/api/v1' + config.url;
      config.headers = {
        "Content-Type": 'application/json',
        "app": 'member_activity'
      }
      break

    case 'vip2022':
      config.url = 'https://vip2022-api.wukongkeyan.com' + config.url;//'https://wxapp-test.keyanhuoye.com/v1' + config.url
      break
  }

  config.headers.Token = window.localStorage.getItem('token')

  // 在发送请求之前做些什么
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
service.interceptors.response.use(function (response) {
  if(response.data.code == 401){
    window.localStorage.removeItem('token')
    location.reload()
  }
  // 对响应数据做点什么
  return response;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});

// 导出 axios 实例
export default service;



// WEBPACK FOOTER //
// ./src/utlis/request.js